import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { AccountObject, DistributionListObject } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { loadAccounts } from 'src/app/store/accounts'
import { loadLocations } from 'src/app/store/locations'
import { loadProductCategories } from 'src/app/store/product-categories'
import { loadProductTypes } from 'src/app/store/product-types'
import { loadProducts } from 'src/app/store/products'
import { loadUsers } from 'src/app/store/users'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { DistributionListComponent } from './distribution-list/distribution-list.component'

export interface DistributionListOverlayOptions {
  company: DeepReadonly<AccountObject>,
  distributionList?: DeepReadonly<DistributionListObject>
}

@Component({
  selector: 'tc-distribution-list-overlay',
  templateUrl: './distribution-list-overlay.component.html',
  styleUrl: './distribution-list-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class DistributionListOverlayComponent {
  private store = inject(Store)
  private dialogData = inject<DistributionListOverlayOptions>(MAT_DIALOG_DATA)
  private dialogRef = inject<MatDialogRef<DistributionListOverlayOptions>>(MatDialogRef)
  protected toaster = inject(ToasterService)

  @ViewChild('tcDistributionList') tcDistributionList: DistributionListComponent

  protected readonly company = this.dialogData?.company
  protected readonly distributionList = this.dialogData?.distributionList

  constructor() {
    this.store.dispatch(loadLocations({}))
    this.store.dispatch(loadAccounts({}))
    this.store.dispatch(loadProducts())
    this.store.dispatch(loadProductCategories())
    this.store.dispatch(loadProductTypes())
    this.store.dispatch(loadUsers({}))
  }

  save() {
    let distributionList = this.tcDistributionList.getDistributionList()
    if (distributionList.name === '') {
      this.toaster.warning('Please fill distribution list name')
    } else {
      this.dialogRef.close(distributionList)
    }
  }

  cancel() {
    this.dialogRef.close()
  }
}
